/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planchoose1Inputs */

const en_planchoose1 = /** @type {(inputs: Planchoose1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your plan`)
};

const de_planchoose1 = /** @type {(inputs: Planchoose1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle deinen Plan`)
};

/**
* | output |
* | --- |
* | "Choose your plan" |
*
* @param {Planchoose1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planchoose1 = /** @type {((inputs?: Planchoose1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planchoose1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planchoose1(inputs)
	return de_planchoose1(inputs)
});
export { planchoose1 as "planChoose" }